import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'
import { useHistory } from '@ztechapps/common.hook'
import { useContext as useOrderContext } from '../../../components/Order/Context'
import { routesDef } from '../../../config/routes'
import { useOrderSignInGuard } from '../../../hooks/useOrderSignInGuard'

/** Checkout button for the invoice preview: routes to cart when the signed-in user matches `order.by`, otherwise prompts sign-in via a generic, PII-free confirm dialog. Hidden when the order no longer needs payment (mirrors GoToCartButton's visibility guard). */
export const InvoiceCheckoutButton = () => {
  const { document, isStillNeedsPayment, canEditUsingStatus } = useOrderContext()
  const history = useHistory()
  const targetCartUrl = routesDef.CartPage.altPath({ orderId: document?._id })
  const { guard } = useOrderSignInGuard({ redirectUrl: targetCartUrl })

  const onClick = () => guard(() => history.push(targetCartUrl))

  return (
    <ShowIf condition={isStillNeedsPayment && canEditUsingStatus}>
      <BusyButton icon="shopping-cart" text="Checkout" onClick={onClick} />
    </ShowIf>
  )
}
